export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.4996 20.9999L20.4996 8.49991L16.3229 8.13528L14.2708 4.80689L3.23438 4.95703L3.48474 16.1936L8.31469 17.0695L8.49962 20.9999L20.4996 20.9999Z"
      fill="#D8D8D8"
    />
    <path
      d="M5 18.0103C3.34315 18.0103 2 16.6671 2 15.0103L2 6.22088C2 4.56402 3.34315 3.22087 5 3.22087L13.7894 3.22087C15.4462 3.22087 16.7894 4.56402 16.7894 6.22087L16.7894 6.35244L16.7894 9.21666L14.7894 9.21666L14.7894 6.35244L14.7894 6.22087C14.7894 5.66859 14.3417 5.22087 13.7894 5.22087L5 5.22087C4.44772 5.22087 4 5.66859 4 6.22088L4 15.0103C4 15.5625 4.44772 16.0103 5 16.0103L5.13156 16.0103L9.2089 16.0101L9.2089 18.0101L5.13156 18.0103L5 18.0103Z"
      fill="currentColor"
    />
    <path
      d="M22 19C21.9999 20.6568 20.6568 22 19 22L10.2109 22C8.55412 22 7.211 20.6568 7.21094 19L7.21094 16.5L9.21094 16.5L9.21094 19C9.211 19.5522 9.65869 20 10.2109 20L19 20C19.5522 20 19.9999 19.5522 20 19L20 10.2109C20 9.65865 19.5523 9.21094 19 9.21094L16 9.21094L16 7.21094L19 7.21094C20.6569 7.21094 22 8.55408 22 10.2109L22 19Z"
      fill="currentColor"
    />
  </svg>
);
